var _excluded = ["components"],
    _excluded2 = ["icons", "colors", "logos", "illustrations", "loader"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { ChakraProvider } from '@chakra-ui/react';
import { MelioWrapper } from '../MelioWrapper';
import { extendTheme } from '../theme';
import { ColorPalettesProvider } from './ColorPalettesProvider';
import { IconsProvider } from './IconsProvider';
import { IllustrationsProvider } from './IllustrationsProvider';
import { LoaderProvider } from './LoaderProvider';
import { LogosProvider } from './LogosProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export var ThemeProvider = _ref => {
  var {
    theme,
    children
  } = _ref;

  var {
    icons,
    colors: {
      components: componentColors
    } = {},
    logos,
    illustrations,
    loader
  } = theme,
      colors = _objectWithoutProperties(theme.colors, _excluded),
      otherThemeFields = _objectWithoutProperties(theme, _excluded2);

  var extendedTheme = extendTheme(_objectSpread({
    colors,
    componentColors
  }, otherThemeFields)); // This is the reason for the `portalZIndex` - https://github.com/chakra-ui/chakra-ui/issues/3269#issuecomment-774484028

  return /*#__PURE__*/_jsx(ColorPalettesProvider, {
    colors: colors,
    children: /*#__PURE__*/_jsx(ChakraProvider, {
      resetCSS: false,
      cssVarsRoot: "melio-wrapper",
      theme: extendedTheme,
      portalZIndex: 40,
      children: /*#__PURE__*/_jsx(IconsProvider, {
        icons: icons,
        children: /*#__PURE__*/_jsx(LogosProvider, {
          logos: logos,
          children: /*#__PURE__*/_jsx(IllustrationsProvider, {
            illustrations: illustrations,
            children: /*#__PURE__*/_jsx(LoaderProvider, {
              loader: loader,
              children: /*#__PURE__*/_jsx(MelioWrapper, {
                children: children
              })
            })
          })
        })
      })
    })
  });
};
//# sourceMappingURL=ThemeProvider.js.map